import { useQuery } from "react-query";
import { toast } from "react-toastify";

import { QuoteServices } from "../api/QuoteService";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin Product Master section
 */
const useListQuote = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(["quote-list", page_no], QuoteServices.quoteList, {
    onSuccess,
    keepPreviousData: true,
    onError,
  });
};

const useViewQuote = (id, onSuccess, onError = onDefaultError) => {
  return useQuery("quote-view", () => QuoteServices.viewQuote({ id }), {
    onSuccess,
    onError,
  });
};

export { useListQuote, useViewQuote };
